class ContentTypePatchConstants {
  public static readonly JSON: string = 'application/json-patch+json';

  public static readonly PDF: string = 'application/pdf';
}

export default ContentTypePatchConstants;
